export default __webpack_public_path__ + "static/media/link.6020ad9d.svg";